import {
    GET_DELIVERY_PARTNERS,
    GET_RESTAURANT_DELIVERY_PARTNER_SETTINGS, RESET_RESTAURANT_DELIVERY_PARTNER_SETTINGS,
    SAVE_DELIVERY_PARNER_SETTINGS
} from '../../../../actions/types';

const INITIAL_STATE = {
    deliveryPartners: [],
    restaurantDeliveryPartner: {}
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_DELIVERY_PARTNERS:
            return {...state, deliveryPartners: action.payload};
        case GET_RESTAURANT_DELIVERY_PARTNER_SETTINGS:
            return {...state, restaurantDeliveryPartner: action.payload};
        case SAVE_DELIVERY_PARNER_SETTINGS:
            return state;
        case RESET_RESTAURANT_DELIVERY_PARTNER_SETTINGS:
            return {...state,
                restaurantDeliveryPartner: null
                };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/restaurants/settings/service/DeliveryProviderReducer.js